import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { FormGroupArrayConfig } from '../../form-group-array.config';

@Component({
  selector: 'form-group-array-content',
  templateUrl: './form-group-array-content.component.html',
  styleUrls: ['./form-group-array-content.component.scss'],
})
export class FormGroupArrayContentComponent {
  @Input() formArray: UntypedFormArray;
  @Input() config: FormGroupArrayConfig;
  @Input() context: object[];
  @Output() addDuplicateClicked: EventEmitter<{
    values: unknown;
    indexval: number;
  }> = new EventEmitter();
  @Output() removeGroupClicked: EventEmitter<number> = new EventEmitter();

  addDuplicateForm(data) {
    this.addDuplicateClicked.emit({
      values: data.values,
      indexval: data.indexval,
    });
  }

  removeGroup(index) {
    this.removeGroupClicked.emit(index);
  }
}
